import { render, staticRenderFns } from "./ViewGatGroup.vue?vue&type=template&id=70c4e950&scoped=true&"
import script from "./ViewGatGroup.vue?vue&type=script&lang=js&"
export * from "./ViewGatGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4e950",
  null
  
)

export default component.exports